import React, { useCallback, useEffect, useState } from 'react';
import MTable from '../../../../../Components/MTable/MTable';
import { useIntl } from 'react-intl';
import { Container } from '../../../../../Components/Container/Container';
import { useAptorApi } from '../../../../../Api';
import { Query } from '@material-table/core';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useStyles } from "../../../AptorAdminModule.styles";
import { Button, Tooltip } from '@material-ui/core'
import { ArrowUpward } from '@material-ui/icons'
import { useFilter } from '../../../../../Components/ListFilter';
import { RepealableName } from '../../../../../Components';



export const InformationBoard = () => {
  const { formatMessage } = useIntl();
  const { api } = useAptorApi();
  const [filters, setFilter] = useFilter();
  const tableRef = React.useRef<any>(null);
  const navigate = useNavigate();
  const classes = useStyles()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  useEffect(() => {
    if (isFiltersInitialized) {
      tableRef.current && (tableRef.current as any).onQueryChange();
    }
  }, [filters, tableRef, isFiltersInitialized]);

  const renderDate = (date?: Date) => {
    return date ? moment(date).format('ll') : undefined;
  };

  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    const updatedQueryParams = Object.keys(filters)
      .filter(key => filters[key]?.join() !== undefined && filters[key]?.join() !== "")
      .map(key => `${key}=${encodeURIComponent(filters[key]?.join())}`)
      .join('&');
    localStorage.setItem("admin-law", updatedQueryParams)
    navigate({
      pathname: location.pathname,
      search: `?${updatedQueryParams}`,
    }, { replace: true });
  }, [filters, navigate, location.pathname]);

  return (
    <>
      <Container fullWidth linkButtonTo="/admin/law-portal/information-board/new" linkButtonLabel="admin.law-portal.add-informationBorad">
        <MTable
          tableRef={tableRef}
          columns={[
            { title: formatMessage({ id: 'admin.law-portal.informationBorad.table.Headline' }), field: 'headline' },
            {
              title: formatMessage({ id: 'admin.law-portal.informationBorad.table.informationtext' }),
              field: 'informationtext',
            },
            {
              title: formatMessage({ id: 'admin.law-portal.informationBorad.table.createDate' }),
              field: 'createDate',
              render: (row: any) => renderDate(row?.createDate),
            },
          ]}
          data={[]}
          actions={[
            (row) => ({
              tooltip: formatMessage({ id: 'component.mtable.editTooltip' }),
              icon: 'edit',
              onClick: () => navigate(`/admin/law-portal/information-board/${row.id}`),
            }),
            (row) =>
              row?.active === true
                ? {
                  tooltip: formatMessage({ id: 'admin.lawportal.informationBoard.inactivate.label' }),
                  icon: 'block',
                  onClick: () => { },
                }
                : {
                  tooltip: formatMessage({ id: 'admin.lawportal.informationBoard.activate.label' }),
                  icon: 'check',
                  onClick: () => { },
                },
            (row) => ({
              tooltip: formatMessage({ id: 'component.mtable.deleteTooltip' }),
              icon: 'delete',
              onClick: () => () => { },
            }),

          ]}
          components={{}}
        />
      </Container>
      {showScrollTop && (
        <Tooltip title={formatMessage({ id: "bottom.to.top.btn.tooltip.text", defaultMessage: "Back to top" })}>
          <Button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={classes.topButton}
          >
            <ArrowUpward style={{ fontSize: 20 }} />
          </Button>
        </Tooltip>
      )}

    </>
  );
};
